import Guest from '@/layouts/guest';
import React, { useEffect } from 'react';
import {Container} from "react-bootstrap";
import ContactContent from "@/components/contact/content";
import { setCanonical } from '@/app/general';

const Contact: React.FC = () => {
  useEffect(() => {
    setCanonical();
  }, []);
  
  return (
    <Guest title="تماس با تکست نویس">
      <Container className="py-5">
        <ContactContent />
      </Container>
    </Guest>
  );
}

export default Contact;
